import { createClient } from '@supabase/supabase-js'

// Get the URL and anon key from environment variables with safe defaults
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL 
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

const supabase = createClient(supabaseUrl, supabaseAnonKey)

export default supabase
